import { setCookie } from '@/utils/utils'

const mutations = {
  // changeTest(state, test) {
  //   state.test = test
  // },
  setActivateVoucher (state, activateVoucher) {
    state.activateVoucher = activateVoucher
  },
  setAuthenticationInfo (state, authenticationInfo) {
    state.authenticationInfo = authenticationInfo
  },
  setProTitleId (state, proTitleId) {
    state.proTitleId = proTitleId
  },
  setOrganizationMessage (state, organizationMessage) {
    state.organizationMessage = organizationMessage
    setCookie('organizationMessage', JSON.stringify(organizationMessage))
  },
  setTissueMessage (state, tissueMessage) {
    state.tissueMessage = tissueMessage
    setCookie('tissueMessage', JSON.stringify(tissueMessage))
  },
  setOrganizationCheckedInfo (state, organizationCheckedInfo) {
    state.organizationCheckedInfo = organizationCheckedInfo
  },
  setMenuIndex (state, menuIndex) {
    state.menuIndex = menuIndex
  },
  setOrganizations (state, organizations) {
    state.organizations = organizations
  },
  setResources (state, resources) {
    state.resources = resources
  },
  setLogoUrl (state, logoUrl) {
    state.logoUrl = logoUrl
  },
  setOrganizationName (state, organizationName) {
    state.organizationName = organizationName
  },
  setItemType (state, itemType) {
    state.itemType = itemType
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js